import React from "react";
import { Table, Card, Accordion, Row, Col, Modal } from "react-bootstrap";
import PersonView from "./PersonView";
import PreviousProgramsView from "./PreviousProgramsView";
import ModalPersonRenderer from "./renderers/ModalPersonRenderer";


interface ProgramsViewProps
{
    data: Programs;
}

interface ProgramsViewState
{
    modalData: any;
    showModal: boolean;
    cOpen: boolean;
}

export default class ProgramsView extends React.Component<ProgramsViewProps, ProgramsViewState>
{
    constructor(props: ProgramsViewProps) 
    {
        super(props);

        this.state = {
            showModal: false,
            modalData: { supervisor: { fullName: "", email: "", imageURL: "" } },
            cOpen: true
        };
    }

    render(): React.ReactNode 
    {
        const current = this.props.data.programs;

        const handleClose = () => this.setState({ showModal: false });
        const handleShow = (itm: any): void =>
        {
            this.setState({ showModal: true, modalData: itm });
        };

        return <React.Fragment>
            <h2>Programs</h2>
            {
                (current && current.length > 0)
                    ?
                    <Accordion defaultActiveKey="0">
                        <Card>
                            <Accordion.Toggle aria-expanded={this.state.cOpen} onClick={() => this.setState({ cOpen: !this.state.cOpen })} href={"javascript:void(0)"} as={"a"} variant="link" eventKey="0">
                                <Card.Header>
                                    <Row>
                                        <Col xs={10}>
                                            <b>CURRENT</b>
                                        </Col>
                                        <Col xs={1} className="text-right chevron">
                                            <i className={this.state.cOpen ? " far fa-chevron-up" : "far fa-chevron-down"}></i>
                                        </Col>
                                    </Row>
                                </Card.Header>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                    <Table responsive className="list">
                                        <thead>
                                            <tr style={{ color: "grey" }}>
                                                <th>TYPE</th>
                                                <th>TERM</th>
                                                <th>TITLE</th>
                                                <th>SUPERVISOR</th>
                                                <th>NOTES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                current.map((program: Program, i: number) => 
                                                {
                                                    return <tr key={i}>
                                                        <td className="td-normal">{program.type ? program.type : " - "}</td>
                                                        <td className="td-normal">{program.termCode ? program.termCode : " - "}</td>
                                                        <td>{program.title ? program.title : " - "}</td>
                                                        <td className="td-normal"><a style={{ color: "#1C4B87" }} onClick={(e): void => handleShow(program.supervisor)}><PersonView data={program.supervisor} /></a></td>
                                                        <td className="td-normal"> {
                                                            program.notes
                                                                ?
                                                                (program.notes.includes("*")) ? "Student or Faculty has not yet submitted an evaluation" : program.notes
                                                                :
                                                                " - "
                                                        }</td>
                                                    </tr>;
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    :
                    <React.Fragment>
                        <b>CURRENT</b>
                        <Card className={"border"}>
                            <Table responsive className="list">
                                <thead>
                                    <tr style={{ color: "grey" }}>
                                        <th>TYPE</th>
                                        <th>TERM</th>
                                        <th>TITLE</th>
                                        <th>SUPERVISOR</th>
                                        <th>NOTES</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="text-center">
                                        <td colSpan={5}>
                                            <p className="error-text">No Program data available</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Card>
                    </React.Fragment>
            }
            <PreviousProgramsView />
            <Modal size={"sm"} centered show={this.state.showModal} onHide={handleClose}>
                <Modal.Body>
                    <ModalPersonRenderer data={this.state.modalData} />
                </Modal.Body>
            </Modal>
        </React.Fragment>;
    }
}